// ===== Algolia sort orders: custom sortBy widget =====
// The app's own sort machinery ignores hook-activated sorts, so we
// remove the default sortBy widget and mount our own with the full
// index list. Replicas title_asc/title_desc are virtual replicas
// configured in the Algolia dashboard.
// NOTE: this file must load at the TOP of <head> WITHOUT defer,
// above {{ content_for_header }}.

/* ---- Collection browse mode ----
 * Wrapped in an IIFE because a bare top-level `return` is a SyntaxError
 * and would kill this entire file. Uses documentElement (not body)
 * because <body> does not exist yet when this runs in <head>.
 */
(function () {
  if (window.__algoliaCustomInit) return;
  window.__algoliaCustomInit = true;

  window.IS_COLLECTION = /^\/collections\//.test(location.pathname);

  if (window.IS_COLLECTION) {
    // Class hook for the CSS that hides the main search box + h1
    document.documentElement.classList.add('ais-browse-mode');

    // Strip stale ?q= so a shared/back-navigated URL doesn't silently
    // filter results with no visible box to explain it
    var u = new URL(location.href);
    if (u.searchParams.has('q')) {
      u.searchParams.delete('q');
      history.replaceState({}, '', u);
    }
  }
})();

(function () {
  function registerSortHooks() {
    // 1) Remove the app's default sortBy widget
    algoliaShopify.hooks.registerHook(
      'afterISStartRemoveDefaultWidget',
      function (defaultWidgets) {
        var sortWidget = defaultWidgets.find(function (w) {
          return w.$$widgetType === 'ais.sortBy';
        });
        return sortWidget ? [sortWidget] : [];
      }
    );

    // 2) Add our own sortBy widget into the same container
    algoliaShopify.hooks.registerHook(
      'beforeISStartAddWidgetArray',
      function () {
        var sortBy = window.algoliaShopify.externals.widgets.sortBy;
        return [
          sortBy({
            container: '.ais-sort',
            items: [
              { value: 'shopify_products',                              label: 'Relevance' },
              { value: 'shopify_products_recently_ordered_count_desc',  label: 'Most popular' },
              { value: 'shopify_products_title_asc',                    label: 'Name A–Z' },
              { value: 'shopify_products_title_desc',                   label: 'Name Z–A' },
              { value: 'shopify_products_published_at_desc',            label: 'Newest first' },
              { value: 'shopify_products_published_at_asc',             label: 'Oldest first' },
              { value: 'shopify_products_price_asc',                    label: 'Price: Low to High' },
              { value: 'shopify_products_price_dsc',                    label: 'Price: High to Low' }
            ]
          })
        ];
      }
    );
  }

  if (window.algoliaShopify && window.algoliaShopify.hooks) {
    registerSortHooks();
  } else {
    document.addEventListener('algolia.hooks.initialize', registerSortHooks);
  }
})();

/* ---- App-only native Autocomplete bridge ----
 * Captures Autocomplete setters via beforeAutocompleteOptions + a plugin
 * subscribe callback so the React Native header can drive the existing
 * Shopify Algolia regular (non-detached) Autocomplete panel.
 *
 * While open, homepage body children are taken out of layout and the
 * panel host becomes normal-flow document content so the WebView root
 * document owns scrolling. Public storefront untouched.
 */
(function () {
  if (window.__sfssAutocompleteBridgeHookRegistered) return;
  window.__sfssAutocompleteBridgeHookRegistered = true;

  var PANEL_HOST_ID = 'sfss-in-app-autocomplete-panel-host';

  function registerAutocompleteBridge() {
    algoliaShopify.hooks.registerHook(
      'beforeAutocompleteOptions',
      function (options) {
        if (!document.documentElement.classList.contains('in-app')) {
          return options;
        }

        // TEMP: remove after confirming this build is loaded in the WebView
        document.documentElement.setAttribute('data-sfss-build', 'detached-0911');

        var setQueryFn = null;
        var setIsOpenFn = null;
        var refreshFn = null;
        var ready = false;
        var latestQuery = '';
        var requestedOpen = false;
        var refreshGeneration = 0;
        var lastPostedQuery = null;
        var lastPostedIsOpen = null;
        var applyingFromBridge = false;
        var lastScrollResetQuery = null;
        var adoptObserver = null;
        var adoptTimeoutId = null;
        var savedBackgroundScrollTop = null;
        var openLatch = false;

        function getDocumentScrollTop() {
          var se = document.scrollingElement || document.documentElement;
          if (typeof window.scrollY === 'number') return window.scrollY;
          return se ? se.scrollTop : 0;
        }

        function scrollDocumentTo(y) {
          try {
            window.scrollTo(0, y);
          } catch (err) {
            var se = document.scrollingElement || document.documentElement;
            if (se) se.scrollTop = y;
          }
        }

        function ensureInAppPanelHost() {
          /* DISABLED (detached-restore): panel host / portal machinery.
          var host = document.getElementById(PANEL_HOST_ID);

          if (!host) {
            host = document.createElement('div');
            host.id = PANEL_HOST_ID;
            (document.body || document.documentElement).appendChild(host);
          }

          if (document.body && host.parentNode !== document.body) {
            document.body.appendChild(host);
          }

          return host;
          */
          return null;
        }

        function moveHostIntoBodyWhenReady() {
          /* DISABLED (detached-restore): panel host creation
          ensureInAppPanelHost();
          if (document.body) return;
          document.addEventListener(
            'DOMContentLoaded',
            function () {
              ensureInAppPanelHost();
            },
            { once: true }
          );
          */
        }

        function stopAdoptObserver() {
          if (adoptObserver) {
            try {
              adoptObserver.disconnect();
            } catch (err) {}
            adoptObserver = null;
          }
          if (adoptTimeoutId != null) {
            clearTimeout(adoptTimeoutId);
            adoptTimeoutId = null;
          }
        }

        function adoptInAppPanel() {
          /* DISABLED (detached-restore): do not relocate .aa-Panel into a theme host.
          var host = ensureInAppPanelHost();
          var panel =
            host.querySelector('.aa-Panel') ||
            document.querySelector('.aa-Panel');

          if (!panel) {
            return false;
          }

          if (!host.contains(panel)) {
            host.appendChild(panel);
          }

          return host.contains(panel);
          */
          return false;
        }

        function scheduleAdoptAttempts() {
          /* DISABLED (detached-restore)
          if (!requestedOpen) return;

          ensureInAppPanelHost();

          if (adoptInAppPanel()) {
            stopAdoptObserver();
            return;
          }

          requestAnimationFrame(function () {
            if (!requestedOpen) return;
            if (adoptInAppPanel()) {
              stopAdoptObserver();
              return;
            }
            requestAnimationFrame(function () {
              if (!requestedOpen) return;
              if (adoptInAppPanel()) {
                stopAdoptObserver();
                return;
              }
              startAdoptObserver();
            });
          });
          */
        }

        function startAdoptObserver() {
          /* DISABLED (detached-restore)
          if (!requestedOpen) return;
          if (adoptObserver) return;
          if (typeof MutationObserver !== 'function') return;

          var root = document.body || document.documentElement;
          adoptObserver = new MutationObserver(function () {
            if (!requestedOpen) {
              stopAdoptObserver();
              return;
            }
            if (adoptInAppPanel()) {
              stopAdoptObserver();
            }
          });
          adoptObserver.observe(root, { childList: true, subtree: true });

          adoptTimeoutId = setTimeout(function () {
            stopAdoptObserver();
          }, 5000);
          */
        }

        function enterOpenMode() {
          if (openLatch) return;
          openLatch = true;
          savedBackgroundScrollTop = getDocumentScrollTop();
          document.documentElement.classList.add('sfss-autocomplete-open');
          requestAnimationFrame(function () {
            if (!requestedOpen) return;
            scrollDocumentTo(0);
          });
        }

        function exitOpenMode() {
          if (!openLatch && !document.documentElement.classList.contains('sfss-autocomplete-open')) {
            savedBackgroundScrollTop = null;
            return;
          }
          openLatch = false;
          document.documentElement.classList.remove('sfss-autocomplete-open');
          var restoreY =
            typeof savedBackgroundScrollTop === 'number'
              ? savedBackgroundScrollTop
              : 0;
          savedBackgroundScrollTop = null;
          requestAnimationFrame(function () {
            scrollDocumentTo(restoreY);
          });
        }

        function syncAutocompleteOpenClass(isOpen) {
          if (isOpen) {
            enterOpenMode();
          } else {
            exitOpenMode();
          }
        }

        function effectiveIsOpen() {
          return requestedOpen && latestQuery.trim().length > 0;
        }

        function postAutocompleteState(query, isOpen) {
          var rn = window.ReactNativeWebView;
          if (!rn || typeof rn.postMessage !== 'function') return;

          try {
            rn.postMessage(
              JSON.stringify({
                type: 'sfss-autocomplete-state',
                query: query,
                isOpen: isOpen
              })
            );
          } catch (err) {
            /* ignore bridge post failures */
          }
        }

        function installPanelInteractionListener() {
          if (window.__sfssAutocompletePanelInteractionInstalled) return;
          window.__sfssAutocompletePanelInteractionInstalled = true;

          function onPanelTouchStart(e) {
            if (!document.documentElement.classList.contains('in-app')) return;
            var target = e.target;
            if (!target || !target.closest) return;
            if (
              !target.closest('.aa-DetachedContainer') &&
              !target.closest('.aa-Panel') &&
              !target.closest('#' + PANEL_HOST_ID)
            ) {
              return;
            }

            var rn = window.ReactNativeWebView;
            if (!rn || typeof rn.postMessage !== 'function') return;

            try {
              rn.postMessage(
                JSON.stringify({ type: 'sfss-autocomplete-panel-interaction' })
              );
            } catch (err) {
              /* ignore */
            }
          }

          // Keyboard dismiss only — once per touchstart, never during drag
          document.addEventListener('touchstart', onPanelTouchStart, {
            capture: true,
            passive: true
          });
        }

        function syncNativeHeaderHeight() {
          var root = document.documentElement;
          var paddingTop = window.getComputedStyle(root).paddingTop;
          var topPx = parseFloat(paddingTop);
          if (paddingTop && paddingTop.indexOf('px') !== -1 && topPx > 0) {
            root.style.setProperty('--sfss-native-header-height', topPx + 'px');
          }

          // Mirror html padding-bottom into a tab-bar var when RN sets it.
          // No dedicated --sfss-native-tab-bar-height injector exists in theme.
          var paddingBottom = window.getComputedStyle(root).paddingBottom;
          var bottomPx = parseFloat(paddingBottom);
          if (paddingBottom && paddingBottom.indexOf('px') !== -1 && bottomPx > 0) {
            root.style.setProperty('--sfss-native-tab-bar-height', bottomPx + 'px');
          }
        }

        function maybeResetDocumentScrollForQueryChange(query) {
          if (query === lastScrollResetQuery) return;
          lastScrollResetQuery = query;
          if (requestedOpen && query.trim().length > 0) {
            scrollDocumentTo(0);
          }
        }

        function applyOpenImmediately() {
          var shouldOpen = effectiveIsOpen();
          if (typeof setIsOpenFn === 'function') {
            setIsOpenFn(shouldOpen);
          }
          syncAutocompleteOpenClass(shouldOpen);

          if (shouldOpen) {
            /* DISABLED (detached-restore): ensureInAppPanelHost(); scheduleAdoptAttempts(); */
          } else {
            stopAdoptObserver();
          }
        }

        function runRefreshAsync(gen) {
          if (!ready) return;
          if (typeof refreshFn !== 'function') return;

          var result;
          try {
            result = refreshFn();
          } catch (err) {
            return;
          }

          if (result && typeof result.then === 'function') {
            result.then(
              function () {
                void gen;
                /* DISABLED (detached-restore): if (requestedOpen) scheduleAdoptAttempts(); */
              },
              function () {
                void gen;
              }
            );
          } else if (requestedOpen) {
            /* DISABLED (detached-restore): scheduleAdoptAttempts(); */
          }
        }

        function applyBridgeState() {
          syncNativeHeaderHeight();
          /* DISABLED (detached-restore): ensureInAppPanelHost(); */
          var gen = ++refreshGeneration;

          maybeResetDocumentScrollForQueryChange(latestQuery);

          if (!ready) return;

          applyingFromBridge = true;
          try {
            if (typeof setQueryFn === 'function') {
              setQueryFn(latestQuery);
            }
          } finally {
            applyingFromBridge = false;
          }

          applyOpenImmediately();
          runRefreshAsync(gen);
        }

        function collectDiagnostics() {
          var host = document.getElementById(PANEL_HOST_ID);
          var panel = document.querySelector('.aa-Panel');
          var panelInsideHost = !!(host && panel && host.contains(panel));
          var se = document.scrollingElement || document.documentElement;
          var rootOverflowY = '';
          var bodyOverflowY = '';
          try {
            rootOverflowY = window.getComputedStyle(document.documentElement).overflowY;
          } catch (err) {}
          try {
            if (document.body) {
              bodyOverflowY = window.getComputedStyle(document.body).overflowY;
            }
          } catch (err2) {}

          return {
            panelFound: !!panel,
            panelInsideHost: panelInsideHost,
            hostParentTag:
              host && host.parentElement
                ? String(host.parentElement.tagName || '').toLowerCase()
                : '',
            documentScrollTop: getDocumentScrollTop(),
            documentScrollHeight: se ? se.scrollHeight : 0,
            documentClientHeight: se ? se.clientHeight : 0,
            savedBackgroundScrollTop:
              typeof savedBackgroundScrollTop === 'number'
                ? savedBackgroundScrollTop
                : null,
            rootOverflowY: rootOverflowY,
            bodyOverflowY: bodyOverflowY
          };
        }

        /* DISABLED (detached-restore): moveHostIntoBodyWhenReady(); */
        installPanelInteractionListener();

        window.addEventListener('pagehide', function () {
          requestedOpen = false;
          refreshGeneration += 1;
          stopAdoptObserver();
          exitOpenMode();
        });

        var bridge = {
          setQuery: function (value) {
            latestQuery = value == null ? '' : String(value);
            requestedOpen = latestQuery.trim().length > 0;
            applyBridgeState();
          },
          open: function () {
            if (latestQuery.trim().length === 0) return;
            requestedOpen = true;
            applyBridgeState();
          },
          close: function () {
            requestedOpen = false;
            refreshGeneration += 1;
            stopAdoptObserver();
            syncAutocompleteOpenClass(false);
            if (typeof setIsOpenFn === 'function') {
              setIsOpenFn(false);
            }
          },
          getState: function () {
            var diagnostics = collectDiagnostics();
            return {
              ready: ready,
              query: latestQuery,
              requestedOpen: requestedOpen,
              panelFound: diagnostics.panelFound,
              panelInsideHost: diagnostics.panelInsideHost,
              hostParentTag: diagnostics.hostParentTag,
              documentScrollTop: diagnostics.documentScrollTop,
              documentScrollHeight: diagnostics.documentScrollHeight,
              documentClientHeight: diagnostics.documentClientHeight,
              savedBackgroundScrollTop: diagnostics.savedBackgroundScrollTop,
              rootOverflowY: diagnostics.rootOverflowY,
              bodyOverflowY: diagnostics.bodyOverflowY
            };
          }
        };

        window.__sfssNativeAutocomplete = bridge;

        // Force Algolia's native detached overlay in-app (same UX as mobile web).
        // Do not portal the panel; leave panelContainer/panelPlacement to Algolia.
        options.detachedMediaQuery = '(min-width: 0px)';
        // DISABLED (detached-restore):
        // options.panelContainer = '#sfss-in-app-autocomplete-panel-host';
        // options.panelPlacement = 'full-width';

        if (!options.plugins) {
          options.plugins = [];
        }

        var alreadyHasBridge = options.plugins.some(function (plugin) {
          return plugin && plugin.name === 'sfss-native-autocomplete-bridge';
        });
        if (!alreadyHasBridge) {
          options.plugins.push({
            name: 'sfss-native-autocomplete-bridge',
            subscribe: function (api) {
              if (!api) return;
              if (typeof api.setQuery === 'function') setQueryFn = api.setQuery;
              if (typeof api.setIsOpen === 'function') setIsOpenFn = api.setIsOpen;
              if (typeof api.refresh === 'function') refreshFn = api.refresh;
              ready = true;
              /* DISABLED (detached-restore): ensureInAppPanelHost(); */
              applyBridgeState();
              /* DISABLED (detached-restore): scheduleAdoptAttempts(); */
            }
          });
        }

        var previousOnStateChange = options.onStateChange;
        options.onStateChange = function () {
          if (typeof previousOnStateChange === 'function') {
            previousOnStateChange.apply(this, arguments);
          }

          var params = arguments[0];
          var state = params && params.state;
          if (!state) return;

          var nextQuery = state.query == null ? '' : String(state.query);

          if (!applyingFromBridge) {
            if (nextQuery !== latestQuery) {
              latestQuery = nextQuery;
              maybeResetDocumentScrollForQueryChange(nextQuery);
            } else {
              latestQuery = nextQuery;
            }
          }

          // requestedOpen === false is authoritative: ignore late isOpen:true
          var reportIsOpen = requestedOpen === false ? false : Boolean(state.isOpen);

          if (requestedOpen === false) {
            syncAutocompleteOpenClass(false);
            stopAdoptObserver();
            if (state.isOpen && typeof setIsOpenFn === 'function') {
              setIsOpenFn(false);
            }
          } else {
            syncAutocompleteOpenClass(reportIsOpen);
            if (reportIsOpen) {
              /* DISABLED (detached-restore):
              ensureInAppPanelHost();
              scheduleAdoptAttempts();
              */
            }
          }

          if (nextQuery === lastPostedQuery && reportIsOpen === lastPostedIsOpen) {
            return;
          }
          lastPostedQuery = nextQuery;
          lastPostedIsOpen = reportIsOpen;

          postAutocompleteState(nextQuery, reportIsOpen);
        };

        return options;
      }
    );
  }

  if (window.algoliaShopify && window.algoliaShopify.hooks) {
    registerAutocompleteBridge();
  } else {
    document.addEventListener('algolia.hooks.initialize', registerAutocompleteBridge);
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  var isRunning = false;
  var target = document.getElementById('algolia-shopify-instantsearch');
  var observer = null;

  // Show the facet search box only when a group has at least this many
  // options. Below it, the list is short enough to scan by eye.
  var SEARCHBOX_MIN_OPTIONS = 8;

  // Number of options shown before the Show All button appears.
  // Must match the nth-child rule in algolia_custom.css.
  var VISIBLE_OPTIONS = 4;

  // Results per page for each display mode. The app's own setting only
  // supports a single value, so the compact ("list") view is bumped
  // client-side — it fits ~6 per row instead of ~4.
  var HITS_GRID = 60;
  var HITS_COMPACT = 90;

  // Below this width the facet panel becomes a modal, groups start
  // expanded, and the Show All button reads "View All".
  // MUST match the mobile media queries in algolia_custom.css (900px).
  var MOBILE_MAX = 900;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function simplifyStatsText() {
    var statsEl = document.querySelector('.ais-Stats-text');
    var countEl = document.querySelector('.ais-stats--nb-results');
    if (!statsEl || !countEl) return;

    var match = countEl.textContent.match(/[\d,]+/);
    if (!match) return;

    statsEl.style.display = 'none';

    var customEl = document.querySelector('.custom-items-count');
    if (!customEl) {
      customEl = document.createElement('span');
      customEl.className = 'custom-items-count';
      customEl.style.fontWeight = '700';
      customEl.style.fontSize = '0.95rem';
      customEl.style.color = '#222';
      statsEl.insertAdjacentElement('afterend', customEl);
    }
    var newText = match[0] + ' items';
    if (customEl.textContent !== newText) {
      customEl.textContent = newText;
    }

    var sortEl = document.querySelector('.ais-sort');
    if (sortEl) {
      for (var i = 0; i < sortEl.childNodes.length; i++) {
        var node = sortEl.childNodes[i];
        if (node.nodeType === 3 && node.textContent.trim().length > 0) {
          node.textContent = '';
        }
      }
    }
  }

  // Adds the Show All / Show Less toggle to groups with more options
  // than VISIBLE_OPTIONS, and removes a stale button when refinements
  // shrink a list below that threshold.
  function addShowAllButtons() {
    var moreLabel = isMobile() ? 'View All' : 'Show All';

    document.querySelectorAll('.ais-RefinementList').forEach(function (refinementEl) {
      var list = refinementEl.querySelector('.ais-RefinementList-list');
      var existing = refinementEl.querySelector('.custom-show-all-btn');

      if (!list) {
        if (existing) existing.remove();
        return;
      }

      if (list.children.length <= VISIBLE_OPTIONS) {
        if (existing) existing.remove();
        list.classList.remove('show-all');
        return;
      }

      if (existing) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-show-all-btn';
      btn.textContent = moreLabel;

      btn.addEventListener('click', function () {
        var isShowingAll = list.classList.toggle('show-all');
        btn.textContent = isShowingAll
          ? 'Show Less'
          : (isMobile() ? 'View All' : 'Show All');
      });

      list.insertAdjacentElement('afterend', btn);
    });
  }

  // Hides the per-facet search box on short lists. Re-evaluated on every
  // render, so it reappears if refinements widen the list again.
  // setProperty(..., 'important') is needed because the CSS sets
  // display:block !important on the search box container.
  function toggleFacetSearchBoxes() {
    document.querySelectorAll('.ais-facets .ais-RefinementList').forEach(function (el) {
      var box = el.querySelector(
        '.ais-SearchBox, .ais-RefinementList-searchBox, .ais-facet--search-box'
      );
      if (!box) return;

      var list = el.querySelector('.ais-RefinementList-list');
      var count = list ? list.children.length : 0;

      if (count >= SEARCHBOX_MIN_OPTIONS) {
        box.style.removeProperty('display');
      } else {
        box.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // Groups the search header into two independent containers:
  //  - .custom-header-left  → item count, filter chips, "Clear all" (wraps freely)
  //  - .custom-header-right → Sort By, View As (fixed, never wraps/moves)
  // On mobile the Filters trigger joins the right group so it shares one
  // row with Sort By, and CSS flips the two groups with column-reverse.
  function organizeSearchHeader() {
    var searchHeader = document.querySelector('.ais-search-header');
    if (!searchHeader) return;

    var statsEl = document.querySelector('.ais-stats-container');
    var chipBar = document.querySelector('.ais-current-refined-values-container');
    var clearBar = document.querySelector('.ais-clear-refinements-container');
    var sortEl = document.querySelector('.ais-sort');
    var displayEl = document.querySelector('.ais-change-display');

    if (!statsEl || !chipBar || !sortEl || !displayEl) return;

    var leftWrap = searchHeader.querySelector('.custom-header-left');
    var rightWrap = searchHeader.querySelector('.custom-header-right');

    if (!leftWrap) {
      leftWrap = document.createElement('div');
      leftWrap.className = 'custom-header-left';
      searchHeader.insertBefore(leftWrap, searchHeader.firstChild);
    }
    if (!rightWrap) {
      rightWrap = document.createElement('div');
      rightWrap.className = 'custom-header-right';
      searchHeader.appendChild(rightWrap);
    }

    // appendChild on an existing node just moves it, so this is safe to
    // run on every mutation without duplicating anything.
    leftWrap.appendChild(statsEl);
    leftWrap.appendChild(chipBar);
    if (clearBar) leftWrap.appendChild(clearBar);

    rightWrap.appendChild(sortEl);
    rightWrap.appendChild(displayEl);

    if (leftWrap.parentElement !== searchHeader) searchHeader.insertBefore(leftWrap, searchHeader.firstChild);
    if (rightWrap.parentElement !== searchHeader) searchHeader.appendChild(rightWrap);

    // Filters trigger: first item in the right group on mobile, back to
    // its own slot on desktop (where CSS hides it anyway).
    var facetsBtn = document.querySelector('.ais-facets-button');
    if (facetsBtn && isMobile() && facetsBtn.parentElement !== rightWrap) {
      rightWrap.insertBefore(facetsBtn, rightWrap.firstChild);
    }

    var chipList = document.querySelector('.ais-current-refined-values--list');
    var hasChips = chipList && chipList.textContent.trim().length > 0;

    chipBar.classList.toggle('is-empty', !hasChips);
    if (clearBar) clearBar.classList.toggle('is-empty', !hasChips);
    chipBar.style.display = '';
    if (clearBar) clearBar.style.display = '';
  }

  // Collapsible facet groups: clicking a header toggles that group.
  // Delegated to #algolia-shopify-instantsearch rather than bound per
  // wrapper — the app re-renders the facet panel by replacing HTML,
  // which copies attributes but not listeners, so per-node binding
  // leaves nodes that look bound (data-collapseInit) but aren't.
  function initFacetCollapse() {
    var root = document.getElementById('algolia-shopify-instantsearch');
    if (!root || root.dataset.collapseDelegated) return;
    root.dataset.collapseDelegated = '1';

    root.addEventListener('click', function (e) {
      var header = e.target.closest('.ais-facet--header');
      if (!header) return;

      var wrap = header.closest('.ais-facet-dropdown-wrapper');
      if (!wrap) return;

      e.preventDefault();
      e.stopPropagation();
      wrap.classList.toggle('facet-collapsed');
      syncCollapseAllLabel();
    });
  }

  // Mobile facet modal. The app renders a .ais-facets-button trigger but
  // never wires it up, so open/close state is ours: .ais-facets-open on
  // <html>, which the CSS keys off.
  //
  // Delegated on `document`, NOT on #algolia-shopify-instantsearch:
  // organizeSearchHeader() relocates the trigger into
  // .custom-header-right, which sits outside that root, so clicks would
  // never bubble to a listener bound there. The guard flag lives on
  // <html> for the same reason — the root element gets re-rendered.
  //
  // NO backdrop-to-close. The facet headers are <label> elements wired
  // to a sibling .ais-dropdown-checkbox, so clicking one dispatches a
  // second synthetic click targeting that input — which is a sibling of
  // .ais-facet--header, so initFacetCollapse's stopPropagation never
  // sees it and it reaches document. Whether that node is still
  // attached by then depends on re-render timing, so an outside-click
  // check reads it as "outside" and closes the modal mid-interaction.
  // The × and Escape are enough; a filter panel that dismisses on a
  // mis-tap is worse than one that needs a deliberate close.
  function initMobileFacets() {
    if (document.documentElement.dataset.mobileFacetsInit) return;
    document.documentElement.dataset.mobileFacetsInit = '1';

    document.addEventListener('click', function (e) {
      if (e.target.closest('.ais-facets-button')) {
        e.preventDefault();
        document.documentElement.classList.add('ais-facets-open');
        return;
      }
      if (e.target.closest('.custom-facets-close')) {
        e.preventDefault();
        document.documentElement.classList.remove('ais-facets-open');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.documentElement.classList.remove('ais-facets-open');
      }
    });

    // never leave the modal open after a resize back to desktop
    window.addEventListener('resize', function () {
      if (!isMobile()) {
        document.documentElement.classList.remove('ais-facets-open');
      }
    });
  }

  // Sticky "FILTERS  ×" bar at the top of the mobile modal. Hidden by
  // CSS on desktop, so it's safe to always insert.
  function addMobileFacetsHeader() {
    var facets = document.querySelector('.ais-facets');
    if (!facets || facets.querySelector('.custom-facets-head')) return;

    var head = document.createElement('div');
    head.className = 'custom-facets-head';
    head.innerHTML =
      '<span class="custom-facets-title">FILTERS</span>' +
      '<button type="button" class="custom-facets-close" aria-label="Close filters">&times;</button>';
    facets.insertBefore(head, facets.firstChild);
  }

  // Compact ("list") view fits more products per row, so ask Algolia for
  // more per page when it's active. The widget flips
  // .ais-change-display-selected between the two buttons; the
  // ais-results-size-* class does not change, so key off the former.
  // Delegated for the same reason as initFacetCollapse.
  function initViewHitsPerPage() {
    var root = document.getElementById('algolia-shopify-instantsearch');
    if (!root || root.dataset.hitsPerPageInit) return;
    root.dataset.hitsPerPageInit = '1';

    root.addEventListener('click', function (e) {
      if (!e.target.closest('.ais-change-display')) return;

      // let the widget flip .ais-change-display-selected first
      setTimeout(function () {
        var listBtn = document.querySelector('.ais-change-display-list');
        var compact = listBtn && listBtn.classList.contains('ais-change-display-selected');
        var want = compact ? HITS_COMPACT : HITS_GRID;

        var helper = window.algoliaShopify &&
          algoliaShopify.instantsearch &&
          algoliaShopify.instantsearch.search &&
          algoliaShopify.instantsearch.search.helper;
        if (!helper) return;

        if (helper.state.hitsPerPage !== want) {
          helper.setQueryParameter('hitsPerPage', want).search();
        }
      }, 0);
    });
  }

function addCollapseAllButton() {
    var facets = document.querySelector('.ais-facets');
    if (!facets) return;

    var btn = facets.querySelector('.custom-collapse-all');

    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-collapse-all';
      facets.insertBefore(btn, facets.firstChild);

      btn.addEventListener('click', function () {
        var collapse = btn.dataset.action !== 'expand';
        facets
          .querySelectorAll('.ais-facet-dropdown-wrapper:not(.facet-empty)')
          .forEach(function (g) {
            g.classList.toggle('facet-collapsed', collapse);
          });
        syncCollapseAllLabel();
      });
    }

    syncCollapseAllLabel();
  }

  function syncCollapseAllLabel() {
    var facets = document.querySelector('.ais-facets');
    var btn = facets && facets.querySelector('.custom-collapse-all');
    if (!btn) return;

    var groups = facets.querySelectorAll(
      '.ais-facet-dropdown-wrapper:not(.facet-empty)'
    );
    var anyOpen = false;
    groups.forEach(function (g) {
      if (!g.classList.contains('facet-collapsed')) anyOpen = true;
    });

    btn.dataset.action = anyOpen ? 'collapse' : 'expand';
    btn.textContent = anyOpen ? 'Collapse all' : 'Expand all';
  }

  // 1) Hide facet groups with no options for the current result set.
  //    The Algolia app still renders the header + chevron when a facet
  //    returns no values. setProperty(..., 'important') is required
  //    because the CSS sets display:flex !important on the wrapper.
  //
  //    Range sliders render no list items at all, so a list-only
  //    selector reports them as populated forever. For those we check
  //    for slider handles instead — a slider with no matching products
  //    renders its track but no handles.
  //
  // 2) Collapse every remaining group the first time it's seen, so the
  //    panel loads compact. data-autoCollapsed makes it once-only, so a
  //    group the user opens stays open across re-renders. Skipped on
  //    mobile: the modal should open showing options, not a wall of
  //    headers.
  function hideEmptyFacets() {
    var OPTION_SELECTOR =
      '.ais-RefinementList-item, .ais-facet--item, .ais-RefinementList-label, ' +
      '.ais-Menu-item, .ais-HierarchicalMenu-item, .ais-NumericMenu-item';

    document
      .querySelectorAll('.ais-facets .ais-facet-dropdown-wrapper')
      .forEach(function (wrap) {
        var hasOptions = !!wrap.querySelector(OPTION_SELECTOR);

        if (!hasOptions) {
          var slider = wrap.querySelector(
            '.ais-RangeSlider, .ais-range-slider--target, .rheostat'
          );
          if (slider) {
            hasOptions = !!slider.querySelector(
              '.rheostat-handle, .ais-RangeSlider-handle, [class*="handle"]'
            );
          }
        }

        wrap.classList.toggle('facet-empty', !hasOptions);

        if (hasOptions) {
          wrap.style.removeProperty('display');
        } else {
          wrap.style.setProperty('display', 'none', 'important');
        }
      });

    if (isMobile()) return;

    document
      .querySelectorAll('.ais-facets .ais-facet-dropdown-wrapper:not(.facet-empty)')
      .forEach(function (wrap) {
        if (!wrap.dataset.autoCollapsed) {
          wrap.dataset.autoCollapsed = '1';
          wrap.classList.add('facet-collapsed');
        }
      });
  }

  function runAll() {
    if (isRunning) return;
    isRunning = true;
    if (observer) observer.disconnect();

    simplifyStatsText();
    addShowAllButtons();
    toggleFacetSearchBoxes();
    organizeSearchHeader();
    initFacetCollapse();
    initViewHitsPerPage();
    initMobileFacets();
    addMobileFacetsHeader();
    hideEmptyFacets();
    addCollapseAllButton();

    if (observer && target) {
      observer.observe(target, { childList: true, subtree: true });
    }
    isRunning = false;
  }

  window.__aisRunAll = runAll;

  runAll();

  if (target) {
    observer = new MutationObserver(function () {
      runAll();
    });
    observer.observe(target, { childList: true, subtree: true });
  }
});
